var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.markerList),function(item){return _c('div',[_c('scene-view-marker-selecting',{attrs:{"markerInfo":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }